<template>
  <transition name="van-slide-down">
    <div class="pc-notice" v-show="isShowNotify">
      <div :style="{ left: left + 'px' }" class="bullet">
        <span class="icontemp notice"></span>
        <span class="notice-content">{{ message }}</span>
      </div>
      <span class="icontemp stemp-close close" @click="close()"></span>
    </div>
  </transition>
</template>

<script>
import $ from "jquery";
import { $subscriber } from "fire-wind-water";
//import ws from "../../services/webinar";
import { buildNoticeMethod, mounted } from "../../common/notice";

export default {
  name: "TopNoticePc",
  data() {
    return {
      message: "",
      left: "-1000", //隐藏
      isShowNotify: false,
      playId: "",
      cleartimer: false,
      outTimeList: [],
      intervalList: []
    };
  },
  watch: {
    isShowNotify() {
      $subscriber.emit("toggleNotifyStatus", this.isShowNotify);
    }
  },
  methods: buildNoticeMethod({
    //消息内容，循环次数默认3
    notify(messageObj, type) {
      console.log('messageObj',messageObj);
      let self = this;
      //      let width = $("#video-main").css("width");
      //      //宽屏的时候需要这么计算
      //      $(".pc-notice").css(
      //        "width",
      //        parseInt(width) - parseInt($("#video").css("padding-left")) * 2 + "px"
      //      );
      self.left = parseInt($(".pc-notice").css("width"));
      if (type === "onNotificationDelete") {
        // 撤回
        if (messageObj._id === self.playId) {
          self.cleartimer = true;
          self.playTimer(0);
          if (self.intervalList.length > 0) {
            self.intervalList.forEach(item => {
              clearInterval(item);
            });
            self.intervalList = [];
          }
          if (self.outTimeList.length > 0) {
            self.outTimeList.forEach(item => {
              clearTimeout(item);
            });
            self.outTimeList = [];
          }
          self.isShowNotify = false;
        }
      } else {
        // 开始广播前需全部清除定时器
        self.cleartimer = true;
        if (self.intervalList.length > 0) {
          self.intervalList.forEach(item => {
            clearInterval(item);
          });
          self.intervalList = [];
        }
        if (self.outTimeList.length > 0) {
          self.outTimeList.forEach(item => {
            clearTimeout(item);
          });
          self.outTimeList = [];
        }
        setTimeout(() => {
          self.cleartimer = false;
          if (type === "initNotifications") {
            // 刚进入页面或刷新页面
            if (!messageObj.deleted) {
              if (messageObj.category === "after_join") {
                // 按时长播放
                let validPeriod =
                  new Date(messageObj.valid_time).getTime() -
                  new Date().getTime();
                if (validPeriod > 0) {
                  self.message = messageObj.content;
                  self.playId = messageObj._id;
                  self.playTimer();
                  self.outTimeList.push(
                    setTimeout(() => {
                      self.playTimer(0); // 清除定时
                      self.cleartimer = true;
                    }, validPeriod)
                  );
                }
              } else if (messageObj.category === "loop") {
                // 循环播放
                self.message = messageObj.content;
                self.playId = messageObj._id;
                let loopValidPeriod =
                  messageObj.valid_period * 60 * 1000 +
                  messageObj.times * 10 * 1000;
                self.playTimer(messageObj.times);
                self.intervalList.push(
                  setInterval(function() {
                    self.left = parseInt($(".pc-notice").css("width"));
                    self.playTimer(messageObj.times);
                  }, loopValidPeriod)
                );
              }
            }
          } else if (type === "onNotification") {
            self.message = messageObj.content;
            self.playId = messageObj._id;
            if (messageObj.category === "immediate") {
              // 按次播放
              self.playTimer(messageObj.times);
            } else if (messageObj.category === "after_join") {
              // 按时长播放
              let validPeriod = messageObj.valid_period * 60 * 1000;
              self.playTimer();
              self.outTimeList.push(
                setTimeout(() => {
                  self.playTimer(0); // 清除定时
                  self.cleartimer = true;
                }, validPeriod)
              );
            } else if (messageObj.category === "loop") {
              // 循环播放
              let loopValidPeriod =
                messageObj.valid_period * 60 * 1000 +
                messageObj.times * 10 * 1000; // PC端按照每条10秒时间计算
              self.playTimer(messageObj.times);
              self.intervalList.push(
                setInterval(function() {
                  self.left = parseInt($(".pc-notice").css("width"));
                  self.playTimer(messageObj.times);
                }, loopValidPeriod)
              );
            }
          }
        }, 10);
      }
    },
    playTimer(num) {
      let self = this;
      let times = 0;
      self.isShowNotify = num !== 0;
      let timer = setInterval(function() {
        self.left = self.left - 1;
        if (self.left < 0 - parseInt($(".bullet").css("width")) && num !== 0) {
          self.left = parseInt($(".pc-notice").css("width"));
          times++;
        }
        if (times == num) {
          self.left = -1000;
          clearInterval(timer);
          self.isShowNotify = false;
        }
        if (self.cleartimer) {
          clearInterval(timer);
        }
      }, 20);
    },
    close() {
      let self = this;
      self.isShowNotify = false;
    }
  }),
  mounted() {
    let self = this;
    mounted(self); //调用公共
    //调整宽度的时候重新计算顶部通知栏的距离
    //    $subscriber.subscribe("changeScreenStatus", function() {
    //      setTimeout(function() {
    //        let width = $("#video").css("width");
    //        $(".pc-notice").css(
    //          "width",
    //          parseInt(width) - parseInt($("#video").css("padding-left")) * 2 + "px"
    //        );
    //      }, 0);
    //    });
  }
};
</script>

<style scoped></style>
